import { Constants } from './olonkho-constants'

export const oTests = [
    {
        type: Constants.TEST_VARIANT,
        text: "«Ымыйа» диэн архаизмҥа сөп түбэһэр быһаарыыны тал: (выбрать правильное определение архаизма «ымыйа»):",
        variants: [
            "Убаҕас аска туттуллар чабычахтыҥы быһыылаах мас иһит (большая деревянная чаша, большая посуда для жидкой пищи).",
            "Кымыс иһэргэ аналлаах саха иһитэ (якутская национальная посуда для питья кумыса).",
            "Саас-сааһынан арахсар туос (cлоистая береста).",
            "Куһаҕан саҥнаах күүс, тыын (недобрая сила, недобрый дух)."
        ],
        correct: 0
    },
    {
        type: Constants.TEST_VARIANT,
        text: "Нууччалыыттан киирии тылы ый (найти русизм):",
        variants: [
            "Кымыс, оппуос.",
            "Сэрэбиэй, солко, аалай.",
            "Сах, быар.",
            "Нохто, быакайда."
        ],
        correct: 1
    },
    {
        type: Constants.TEST_VARIANT,
        text: "Бэриллибит этиилэртэн сомоҕо домоҕу ый (указать фразеологизм):",
        variants: [
            "Өлбөт үөстээх, быстыбат тыыннаах киһи эбит",
            "Хайҕахтаах хара быара буолаарай.",
            "Эйиэхэ кэлэммин ытыы-соҥуу олоробун.",
            "Үс үрэллибит үрүҥ көмүс үрэйэ."
        ],
        correct: 0
    },
    {
        type: Constants.TEST_VARIANT,
        text: "Нууччалыыттан киирии буолбатах тылы ый (указать слово, не являющееся русизмом):",
        variants: [
            "Кумааҕы.",
            "Сэрэбиэй.",
            "Оппуос.",
            "Сах."
        ],
        correct: 3
    },
    {
        type: Constants.TEST_VARIANT,
        text: "«Дук гынан ааһар» диэн тыл ситимин суолтатын ый (выбрать правильное толкование выражения):",
        variants: [
            "Кими-тугу эмэ илиигинэн эбэтэр тугунан эмэ таарый (прикоснуться к чему-либо рукой или дотронуться до кого-чего-либо каким-либо предметом, ткнуть).",
            "Улахан дорҕоонноохтук тыаһаа-ууһаа; улаханнык дуораһый (издавать громкие, раскатистые звуки, греметь).",
            "Туохха эмэ охсуллан бүтэҥитик тыаһаа (издавать глухой дробный стук, ударяясь друг о друга).",
            "Салыбырыыр курдук, салыбыратан (так, чтобы висело, держа на весу)."
        ],
        correct: 0
    },
    {
        type: Constants.TEST_VARIANT,
        text: "«Чиккэйэн турар» диэн тыл ситимин суолтатын тал (Указать правильное толкование выражения):",
        variants: [
            "Төбөҕүн, көхсүгүн кэннин диэки ыытан, көбүс-көнөтүк чыначчы тутун (выпрямиться, вытянуться в струнку, встать навытяжку).",
            "Кими-тугу эмэ илиигинэн эбэтэр тугунан эмэ таарый (прикоснуться к чему-либо рукой или дотронуться до кого-чего-либо каким-либо предметом, ткнуть).",
            "Ыраахтан улаатан багдайан көһүн (казаться издали огромным).",
            "Төҥкөйбүт, бөкчөйбүт курдук тутун (кыра уҥуохтаах, кырдьаҕас киһи туһунан) (сгорбившись, съёжившись (о пожилом человеке небольшого роста)."
        ],
        correct: 0
    },
    {
        type: Constants.TEST_VARIANT,
        text: "«Оноҕос» диэн архаизмҥа сөп түбэһэр быһаарыыны бул (найти определение архаизма «оноҕос»):",
        variants: [
            "Хайаҕа, сыырга тахсар аартык, дабаан (дорога вверх по склону).",
            "Дьылҕа, оҥоруу, анал (cудьба, рок, участь).",
            "бэргэһэ оройуттан намылыйан дугалыы түспүт куорсун эбэтэр түү (перо, висящее дугой на верхушке, макушке шапки).",
            "Былыр сүнньүнэн булка туттуллар ох, үксүгэр куобаҕы бултуурга аналлаах (в старину: стрела, применяемая в основном на охоте, обычно на зайцев)."
        ],
        correct: 3
    },
    {
        type: Constants.TEST_VARIANT,
        text: "«Уолан быстар уулаах,\nОлохсуйан хагдарыйар оттоох,\nОхтон баранар мастаах,\nСиҥнэн сиэмэтэ быстыбат»\nдиэн кэрчик суолтатын тал (выбрать правильное определение фрагмента из олонхо):",
        variants: [
            "Уйгута-быйаҥа бараммакка алла турар сир.",
            "Уйгута-быйаҥа бүппүт сир.",
            "Ыраахтан улаатан багдайан көстөр сир."
        ],
        correct: 0
    },
    {
        type: Constants.TEST_VARIANT,
        text: "«Күөкэримэ» диэн тылга сөп түбэһэр быһаарыыны бэлиэтээ (выбрать определение лексемы «күөкэримэ»):",
        variants: [
            "Уһун (длинный).",
            "Куһаҕан саҥнаах күүс, тыын (недобрая сила, недобрый дух).",
            "Былыр сүнньүнэн булка туттуллар ох, үксүгэр куобаҕы бултуурга аналлаах (в старину: стрела, применяемая в основном на охоте).",
            "Дьылҕа, оҥоруу, анал (cудьба, рок, участь)."
        ],
        correct: 0
    },
    {
        type: Constants.TEST_VARIANT,
        text: "Бэриллибит этиилэртэн тэҥнэбили ый (найти среди данных предложений сравнение):",
        variants: [
            "Сэттэ кыталык элэмэс дьүһүннээх, чоккуруос харахтаах, аҕыс ардайдаах сиэллээх ытык сылгы.",
            "Түргэн холлорук дьүөрэлэһэн түстэ, сипсиэр холлорук эркиннэһэн түстэ.",
            "Нөҥүө кулгаах тааһыгар дылы иэмэх курдук иҥнэри тардан турда."
        ],
        correct: 2
    },
    {
        type: Constants.TEST_VARIANT,
        text: "«Үөлэс» диэн тыл быһаарыытын бул (найти значение слова «Үөлэс»):",
        variants: [
            "Разновидность якутского камелька.",
            "Дымовая труба камелька.",
            "Название якутского балагана."
        ],
        correct: 1
    },
    {
        type: Constants.TEST_VARIANT,
        text: "Нууччалыыттан киирии тылы ый (указать русизм):",
        variants: [
            "Боруок.",
            "Биллэрик.",
            "Ситии."
        ],
        correct: 0
    },
    {
        type: Constants.TEST_VARIANT,
        text: "Үһүгэр сылдьар, үс саастаах дьиэ сүөһүтэ (найти слово, обозначающее «трехгодовалый молодняк домашних животных (коров и лошадей)»):",
        variants: [
            "Тамыйах.",
            "Тиҥэһэ.",
            "Торбос."
        ],
        correct: 1
    },
    {
        type: Constants.TEST_VARIANT,
        text: "Бэриллибит этиилэртэн сомоҕо домоҕу ый (выбрать фразеологизм):",
        variants: [
            "Биэс тарбахтаах диэлийбэтэ, татаар тыллаах таба эппэтэ.",
            "Аҕыс иилээх-саҕалаах, атааннаах-мөҥүөннээх айгыр силик.",
            "Тоҕус мастаах хойуук оҥочону умсары бырахпыт курдук."
        ],
        correct: 0
    },
    {
        type: Constants.TEST_VARIANT,
        text: "Нууччалыыттан киирии тылы ый (указать заимствованное из русского языка слово):",
        variants: [
            "Сымара.",
            "Боруок.",
            "Оҥочо."
        ],
        correct: 1
    },
    {
        type: Constants.TEST_VARIANT,
        text: "Бэриллибит этиилэртэн тэҥнэбили ый (выбрать среди данных предложений сравнение):",
        variants: [
            "Сирэйин хаба оттотугар баар улуу оҕус сыарҕатын курдук оҥойо сытыйбыт соҕотох таныы үүттээх.",
            "Уу харахтаах утары көрбөтө, уон тыҥырахтаах утары ууммата.",
            "Биэс тарбахтаах диэлийбэтэ, татаар тыллаах таба эппэтэ."
        ],
        correct: 0
    },
    {
        type: Constants.TEST_VARIANT,
        text: "Бэриллибит тыллартан эргэрбит тылы ый (выбрать архаизм):",
        variants: [
            "Айхал.",
            "Холлоҕос.",
            "Сэлиэнэй."
        ],
        correct: 2
    },
    {
        type: Constants.TEST_VARIANT,
        text: "“Торҕо сиигин сииктээ” диэн тыл ситимин суолтатын тал (выбрать правильное толкование образного выражения):",
        variants: [
            "Төрдүгэр-төбөтүгэр тиийэ ымпыктаан-чымпыктаан быһааран бил (прояснить что-либо основательно, до конца). ",
            "Биир күрүс баһыйар өҥтөн уратыланар элбэх чуоҕурдаах, бээтинэлээх (имеющий множество пятен, крапин другого цвета по отношению к основной окраске, пестрый, крапчатый).",
            "Сиппит хоппут, муҥутаабыт, күөҕүнэн симэммит (покрытая густой зеленью, разукрашенная роскошным зеленым ковром)."
        ],
        correct: 0
    },
    {
        type: Constants.TEST_VARIANT,
        text: "Нууччалыыттан киирии тылы ый (указать русизм):",
        variants: [
            "Хоруол.",
            "Дойду.",
            "Таныы."
        ],
        correct: 0
    },
    {
        type: Constants.TEST_ANSWER,
        text: "Архаизмнар суолталарын быһаар (дать объяснение значения архаизмов): ",
        exercises: [
            {
                question: "1. Дьабака",
                answer: "дьахтар бэргэһэтэ (женская шапка).",
                answers: ["дьахтар бэргэһэтэ", "женская шапка"]
            },
            {
                question: "2. Модьоҕо",
                answer: "аан боруога (дверной порог).",
                answers: ["аан боруога", "дверной порог"]
            },
            {
                question: "3. Сүллүгэс",
                answer: "охсуһарга аналлаах баалкы (палка, используемая в схватке, в бою).",
                answers: ["охсуһарга аналлаах баалкы", "палка, используемая в схватке, в бою"]
            },
            {
                question: "4. Эбир былыт",
                answer: "быһыттаҕас былыт (перистые облака).",
                answers: ["быһыттаҕас былыт", "перистые облака"]
            },
            {
                question: "5. Үөмэх былыт",
                answer: "хойуу былыт (группа тёмных облаков). ",
                answers: ["хойуу былыт", "группа тёмных облаков"]
            },
            {
                question: "6. Сата былыт",
                answer: "аптаан ыҥырыллыбыт былыт (облако, вызванное колдовством).",
                answers: ["аптаан ыҥырыллыбыт былыт", "облако, вызванное колдовством"]
            },
        ]
    },
    {
        type: Constants.TEST_ANSWER,
        text: "Историзмнар суолталарын быһаар (укажите определение историзмов)",
        exercises: [
            {
                question: "1. Чаачар",
                answer: "саа. (лук, оружие).",
                answers: ["саа", "лук", "оружие"]
            },
            {
                question: "2. Чороон ымыйа",
                answer: "кэритэн иһэргэ аналлаах чороон (старинный сосуд для питья кумыса по кругу).",
                answers: ["кэритэн иһэргэ аналлаах чороон", "старинный сосуд для питья кумыса по кругу"]
            },
            {
                question: "3. Сири иһит",
                answer: "тирииттэн тигиллибит үүт аһылыкка наллаах иһит (сосуд из выделанной кожи для молочных продуктов). ",
                answers: ["тирииттэн тигиллибит үүт аһылыкка наллаах иһит", "сосуд из выделанной кожи для молочных продуктов"]
            },
            {
                question: "4. Куойа-куйуур",
                answer: "рыболовный сак.",
                answers: ["рыболовный сак"]
            },
            {
                question: "5. Маҥкы",
                answer: "куйуур уга (рукоятка рыболовного сака).",
                answers: ["куйуур уга", "рукоятка рыболовного сака"]
            },
            {
                question: "6. Хатат",
                answer: "кремень для получения огня.",
                answers: ["кремень для получения огня"]
            },
        ]
    },
    {
        type: Constants.TEST_ANSWER,
        text: "Бэриллибит тыл ситимнэрин суолталарын быһаар (объяснить значение образных выражений):",
        exercises: [
            {
                question: "1. Сиэллэрэн дьигиһитэн истэ ",
                answer: "ехал рысью, трясясь",
                answers: ["ехал рысью, трясясь"]
            },
            {
                question: "2. Барыкыс гынна",
                answer: "эмискэ баар буолла (возник внезапно).",
                answers: ["эмискэ баар буолла", "возник внезапно"]
            },
            {
                question: "3. Тэһиин тутар дьэллик маҕан уолаттар",
                answer: "чаҕар, хамначчыт уолаттар (парни-слуги).",
                answers: ["чаҕар, хамначчыт уолаттар", "парни-слуги"]
            },
            {
                question: "4. Ыпсыыта суох ырыа ",
                answer: "ис хоһооно суох ырыа (нескладная песня).",
                answers: ["ис хоһооно суох ырыа", "нескладная песня"]
            },
        ]
    },
    {
        type: Constants.TEST_VARIANT,
        text: "«Үрүт уйалаах, ордук мутуктаах» диэн сомоҕо домоххо сөп түбэспэт быһаарыыны тал (Выбрать определение, не подходящее данному фразеологизму):",
        variants: [
            "Лаппа чорбойор киһи.",
            "Тугунан эрэ ордук/ордор киһи.",
            "Кириһинэн намыһах киһи.",
            "Кириһинэн ордук киһи."
        ],
        correct: 2
    },
    {
        type: Constants.TEST_VARIANT,
        text: "Олоҥхо олук хоһоонун ситэр (Дополнить пропуск подходящим словом):\nКөрдөр хараҕым .........\nКөтүрдэр тииһим миилэтэ.",
        variants: [
            "Дьүккэтэ",
            "Көмүскэтэ",
            "Харата",
            "Көнньүөрэ"
        ],
        correct: 0
    },
    {
        type: Constants.TEST_VARIANT,
        text: "Историзм буолбатах тылы булан бэлиэтээ (найти слово-не историзм):",
        variants: [
            "Оноҕос",
            "Халҕан",
            "Биллэрик",
            "Көйүү кымыс"
        ],
        correct: 1
    },
    {
        type: Constants.TEST_VARIANT,
        text: "«Ылгын» диэн архаизм сөп быһаарыытын тал (выбрать определение архаизма «ылгын»):",
        variants: [
            "Орто сөмүйэ",
            "Улахан сөмүйэ",
            "Кыра сөмүйэ",
            "Ыйар сөмүйэ"
        ],
        correct: 2
    },
    {
        type: Constants.TEST_VARIANT,
        text: "Нууччалыыттан киирии тылы ый (указать слово-русизм):",
        variants: [
            "Тайҕа",
            "Тыа",
            "Ойуур",
            "Чараҥ"
        ],
        correct: 0
    },
    {
        type: Constants.TEST_VARIANT,
        text: "Өс хоһоонун ситэрэн биэр (дополнить  пословицу):\nСурт кэриэстээх, .........",
        variants: [
            "Өтөх чөҥөчөктөөх",
            "Өтөх төҥүргэстээх",
            "Балаҕан баҕаналаах",
            "Балаҕан эркиннээх"
        ],
        correct: 1
    },
    {
        type: Constants.TEST_VARIANT,
        text: "Олоҥхо олук хоһоонун ситэр (вставить в эпическую формулу подходящее словосочетание):\nСаамал кымыһынан .........\nКөйүү кымыһынан көхсүн көнньүөртэ",
        variants: [
            "Санаатын сааһыланна",
            "Күөмэйин чөллөрүттэ",
            "Уоһун өһүллэ",
            "Санаатын тарҕатта"
        ],
        correct: 3
    },
    {
        type: Constants.TEST_VARIANT,
        text: "Сомоҕо домоҕу ситэрэн биэр (дополнить фразеологизм):\nСүрэҕим ытарҕата, .........",
        variants: [
            "Быарым тулаайаҕа",
            "Куолайым сүлүһүнэ",
            "Көхсүм көнньүөрэ",
            "Санаам дала"
        ],
        correct: 0
    },
    {
        type: Constants.TEST_VARIANT,
        text: "«Бэлкэй» диэн архаизм сөп быһаарыытын бул (выбрать определение архаизма):",
        variants: [
            "Саамай кыра кытыйа",
            "Саамай кыра ыаҕас",
            "Саамай кыра хамыйах",
            "Саамай кыра чороон"
        ],
        correct: 3
    },
    {
        type: Constants.TEST_VARIANT,
        text: "«Таныыта тартах гынна» диэн тыл ситимин суолтатын тал (выбрать подходящее определение выражения «таныыта тартах гынна»):",
        variants: [
            "Үөрдэ, өрүкүйдэ",
            "Куччаата, кумуйда",
            "Кэҥээтэ, улаатта",
            "Сырдаата, сандаарда"
        ],
        correct: 2
    },
    {
        type: Constants.TEST_VARIANT,
        text: "Киһи илиитин эрбэҕиттэн иккис тарбах сөптөөх аатын тал (выбрать название указательного пальца):",
        variants: [
            "Ылгын чыҥыйа",
            "Сөмүйэ",
            "Эрбэх",
            "Ортоку тарбах"
        ],
        correct: 1
    },
    {
        type: Constants.TEST_VARIANT,
        text: "“Аанай абам эбит, туонай сүптүм эбит” диэн саҥа аллайыы тугу көрдөрөрүн быһаар (выбрать правильное определение междометия):",
        variants: [
            "Соһуччу үөрүүнү ойуулаан көрдөрөр",
            "Аллара дойдуга аттаныах иннинэ бэлэмнэниини көрдөрөр",
            "Сүктэр кыыс ыал буолар күнүгэр мэлдьи туттар этиитэ",
            "Улаханнык абарыыны, кыйаханыыны көрдөрөр"
        ],
        correct: 3
    },
    {
        type: Constants.TEST_VARIANT,
        text: "«Айгыр-силик» диэн эпитет суолтатын ый (указать правильное определение эпитета):",
        variants: [
            "Аймалҕаннаах, айдааннаах",
            "Айгыраабыт, кэхтибит",
            "Сиппит-хоппут, күөҕүнэн симэммит",
            "Киэҥ, кэтит"
        ],
        correct: 2
    },
    {
        type: Constants.TEST_VARIANT,
        text: "Историзм буолбатах тылы ый (выбрать слово, которое не является историзмом):",
        variants: [
            "Болгуо",
            "Хаппар",
            "Кыл",
            "Удьаа"
        ],
        correct: 2
    },
    {
        type: Constants.TEST_VARIANT,
        text: "«Биир сымыыт ханна .........» диэн сомоҕо домоҕу ситэр (докончить фразеологизм):",
        variants: [
            "Алдьамматаҕай",
            "Сытыйбатаҕай",
            "Сылыйбатаҕай",
            "Сыппатаҕай"
        ],
        correct: 1
    },
    {
        type: Constants.TEST_VARIANT,
        text: "Олоҥхо олук хоһоонун ситэрэн биэр (докончить эпическую формулу):\nИр суолун ирдээн, .........",
        variants: [
            "Тоҥ буорун тобулан",
            "Биир суолу көрдөөн",
            "Тор суолун тордоон",
            "Сир суолун сирдээн"
        ],
        correct: 2
    },
    {
        type: Constants.TEST_VARIANT,
        text: "«Суор» диэн тыл атыннык туох дэнэрин ый (указать другое название ворона):",
        variants: [
            "Тураах",
            "Хараҥаччы",
            "Харгыйа",
            "Кэкэ-бука"
        ],
        correct: 2
    },
    {
        type: Constants.TEST_VARIANT,
        text: "«Куорай далаан» диэн эпитет ойуулуур тылын ый (найти определяемое слово эпитета «Куорай далаан»):",
        variants: [
            "Ытыс",
            "Кулгаах",
            "Тобук",
            "Мурун"
        ],
        correct: 0
    },
    {
        type: Constants.TEST_VARIANT,
        text: "Нууччалыыттан киирбит тылы бул (найти заимствованное из русского языка слово):",
        variants: [
            "Буукса",
            "Болгуо",
            "Буолунай",
            "Суккуй"
        ],
        correct: 2
    },
    {
        type: Constants.TEST_VARIANT,
        text: "Бу тыл пааралыы тылын бул (указать  парное слово):\nЭлэй-...",
        variants: [
            "Эрэй",
            "Балай",
            "Эриэккэс",
            "Баллай"
        ],
        correct: 1
    },
]